import { type FunctionComponent, type ReactNode, useEffect } from 'react';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { type EventMessage, EventType, InteractionType } from '@azure/msal-browser';
import { useAppDispatch } from './AppContextProvider/AppContextProvider';
import SplashScreen from './SplashScreen';
import { trackLogin } from '../utils/rate-app-utils';
import authClient from '../services/MsalInstance';

interface Props {
  children: ReactNode;
}

const AuthProvider: FunctionComponent<Props> = ({ children }) => {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    authClient.addEventCallback((message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        trackLogin(appDispatch);
      }
    });
  }, []);

  return (
    <MsalProvider instance={authClient}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} loadingComponent={SplashScreen}>
        {children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default AuthProvider;
